import axios from "axios";

// export const baseURL = "http://localhost:5005";
export const baseURL = "https://api.odijn.com";

export const publicClient = axios.create({
  // baseURL: "http://localhost:5005/api",
  baseURL: "https://api.odijn.com/api",
  headers: {
    "Content-Type": "application/json",
  },
});

export const privateClient = axios.create({
  // baseURL: "http://localhost:5005/api",
  baseURL: "https://api.odijn.com/api",
  headers: {
    "Content-Type": "application/json",
  },
});
